import resizer from './resizer'
// tsc .\src\directives\resizer\resizer.ts --target ES2016

const install = function(Vue) {
  Vue.directive('cube-resizer', resizer)
}

if (window.Vue) {
  window.resizer = resizer
  Vue.use(install) // eslint-disable-line
}

resizer.install = install
export default resizer
